import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const TeamBillingOverview = lazy(() => import('.'))

class TeamBillingOverviewWebComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['team-id', 'team-uuid']
	}

	override render() {
		return (
			<PageRoot>
				<TeamBillingOverview
					teamId={Number(this.prop('team-id'))}
					teamUuid={this.prop('team-uuid')}
				/>
			</PageRoot>
		)
	}
}

customElements.define('team-billing-overview', TeamBillingOverviewWebComponent)
